import type { SCFontItem } from 'types/fonts';
import type { IUserOrganization } from 'types/user';
import { createFontResolver, type ResolvedFont } from './font-resolver';

/** Resolve first; callers register all faces atomically only after lookup succeeds. */
export function resolveTokenFonts(
	families: string[],
	storyFonts: Record<string, SCFontItem> | undefined,
	organization: IUserOrganization
): ResolvedFont[] {
	const resolver = createFontResolver({
		storyFonts,
		organizationFonts: organization.metadata?.fonts,
		googleFonts: [],
	});
	return families.map(family => {
		const font = resolver.resolveExact(family);
		if (!font) throw new Error(`Font "${family}" is unavailable. Upload it in Fonts or choose another token.`);
		return font;
	});
}
